import { EntityLinks } from '@griply/types';
import { useMutation } from '@tanstack/react-query';
import { transformGoalSectionToGoal } from 'shared/services/backend-api';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';

export type Options = {
  goal: Goal;
  sectionId: ID;
  isSubGoal?: boolean;
  links: EntityLinks;
};

export const useTransformSectionToGoalMutation = () =>
  useMutation({
    mutationFn: ({ goal, sectionId, isSubGoal, links }: Options) =>
      transformGoalSectionToGoal(sectionId, { goal, isSubGoal, links }),
  });
